import { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";
import DatePicker from "../GenericTable/CommonDatePicker"; // Ensure DatePicker is correctly imported
import { getChartData } from "../../../api";


const ConversionRateChart = () => {
  const [chartData, setChartData] = useState<{ categories: string[]; series: { name: string; type: string; data: any[] }[] }>({
    categories: [],
    series: [],
  });
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getChartData();
        console.log("Fetched Chart Data:", data);
        setChartData(data); // Update state with API data
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const option = {
    tooltip: { trigger: "axis" },
    legend: { top: 0 },
    grid: { 
      left: "3%",  
      right: "2%",  
      top: "10%",  
      bottom: "20%", 
      containLabel: true 
    },
    xAxis: { 
      type: "category", 
      data: chartData.categories,
      axisLine: { show: true },  
      axisTick: { show: true },  
      splitLine: { show: false },
    },
    yAxis: { 
      type: "value",
      splitLine: { show: true }, 
    },
    series: chartData.series,
    dataZoom: [
      {
        type: "inside",
        start: 0,
        end: 100,
      },
      {
        type: "slider",
        start: 0,
        end: 100,
      },
    ],
  };
  
  
  

  return(
    <div>
      <ReactECharts option={option} style={{ height: "250px" }} />
    </div>
  )
   
};

export default ConversionRateChart;
